<script>
import NavBar from './components/NavBar.vue'
import FooterBar from './components/FooterBar.vue'

export default {
  name: 'App',
  components: {
    NavBar,
    FooterBar
  }
}
</script>

<template>
  <div class="app">
    <NavBar />
    <main>
      <router-view />
    </main>
    <FooterBar />
  </div>
</template>
